<div style="background-color: #214953">
  <div class="container-fluid w-100 mx-auto pt-3" style="max-width: 1500px">
    <div class="row px-3 py-2 mb-3 mb-lg-0">
      <div class="col-12 col-md-6 px-0">
        <div
          class="h-100 d-flex align-items-center justify-content-start justify-content-lg-start mb-3 mb-lg-0"
        >
          <div>
            <pla-platex-direct
              class="platex-logo"
              [colour]="'white'"
              [direct]="false"
              [platePortal]="true"
            ></pla-platex-direct>
            <p class="fs-md-12 my-0 text-white text-start text-md-center">
              Version {{ versionNo }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 order-2 order-md-1"></div>
      <div class="col-12 col-md-6 px-0">
        <div class="text-lg-end text-start">
          <p class="lh-base fs-md-12 text-white my-0">
            {{ plateCount | number }}
          </p>
          <p class="lh-base fs-md-12 text-white my-0">
            Registrations available now
          </p>
        </div>
      </div>
    </div>

    <div class="row px-3 mb-3">
      <div
        class="ps-0 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pe-0 text-start text-lg-start mb-3 mb-lg-0"
      >
        <p class="fw-bold mt-0 mb-0" style="color: #fab82b">BUY</p>
        <a href="/buy" class="mb-1 text-decoration-none d-block text-white"
        >Search personal plates for sale</a
        >
        <a
          href="/initials-search"
          class="mb-1 text-decoration-none d-block text-white"
        >Search for your Initial plate</a
        >
        <a
          href="/byo-search"
          class="mb-1 text-decoration-none d-block text-white"
        >Build-Your-Own private plate</a
        >
        <a
          href="/new-release/25"
          class="mb-1 text-decoration-none d-block text-white"
        >Search new released plates</a
        >
        <a
          href="/under-200"
          class="mb-0 text-decoration-none d-block text-white"
        >Plates for less than £200</a
        >
      </div>
      <div
        *ngIf="false"
        class="d-none border-start border-light col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="fw-bold mt-0 mb-0" style="color: #fab82b">SELL</p>
        <a href="" class="mb-1 text-decoration-none d-block text-danger"
        >How to value a number plate</a
        >
        <a href="" class="mb-1 text-decoration-none d-block text-danger"
        >How much is my plate worth</a
        >
        <a href="" class="mb-1 text-decoration-none d-block text-danger"
        >Sell on PlateX</a
        >
        <a href="" class="mb-1 text-decoration-none d-block text-danger"
        >How to sell safely online</a
        >
        <a href="" class="mb-0 text-decoration-none d-block text-danger"
        >Sell my plate</a
        >
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <a
          href="/articles/number-plate-types"
          class="text-decoration-none d-block fw-bold mt-0 mb-0"
          style="color: #fab82b"
        >Number Plate Types</a
        >
        <a
          href="/articles/private-number-plates"
          class="mb-1 text-decoration-none d-block text-white"
        >Private number plates</a
        >
        <a
          href="/articles/cherished-number-plates"
          class="mb-1 text-decoration-none d-block text-white"
        >Cherished number plates
        </a>
        <a
          href="/articles/dateless-number-plates"
          class="mb-1 text-decoration-none d-block text-white"
        >Dateless number plates</a
        >
        <a
          href="/articles/prefix-number-plates"
          class="mb-1 text-decoration-none d-block text-white"
        >Prefix number plates</a
        >
        <a
          href="/articles/suffix-number-plates"
          class="mb-0 text-decoration-none d-block text-white"
        >Suffix number plates</a
        >
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="fw-bold mt-0 mb-0" style="color: #fab82b">Topics</p>
        <a
          href="/articles/how-to-transfer-a-registration"
          class="mb-1 text-decoration-none d-block text-white"
        >How to transfer a registration</a
        >
        <a
          href="/articles/how-to-retain-a-registration"
          class="mb-1 text-decoration-none d-block text-white"
        >How to retain a registraion</a
        >
        <a href="/blogs" class="mb-1 text-decoration-none d-block text-white"
        >Number Plate News</a
        >
        <a
          class="mb-1 text-decoration-none d-block text-white"
          data-nosnippet
          style="cursor: pointer"
          id="open_preferences_center"
        >Update cookies preferences</a
        >
        <a
          class="mb-1 text-decoration-none d-block text-white"
          data-nosnippet
          href="mailto:info@platex.co.uk"
        >Contact us</a
        >
        <a href="/about-us" class="mb-1 text-decoration-none d-block text-white"
        >About Us</a
        >
        <a href="/privacy-policy" class="mb-1 text-decoration-none d-block text-white"
        >Privacy Policy</a
        >
        <a href="/data-deletion" class="mb-0 text-decoration-none d-block text-white"
        >Data Deletion</a
        >
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="fw-bold mt-0 mb-0" style="color: #fab82b">Legal</p>
        <a href="/privacy-policy" class="mb-1 text-decoration-none d-block text-white">Privacy Policy</a>
        <a href="/data-deletion" class="mb-1 text-decoration-none d-block text-white">Data Deletion</a>
      </div>
    </div>

    <div
      class="border-top border-light row px-3 py-3"
      style="border-color: #707070 !important"
    >
      <div class="col-md-5 col-12 ps-0">
        <p
          class="w-100 d-block fs-md-12 my-0 text-white text-center text-lg-start lh-base"
        >
          {{ currentUrl === '/about-us' ? 'PlateX is operated by Plate Tech Ltd, a company registered in England and Wales. Company Number: 16268508. Registered Office: 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ.' : 'Site Design & Build by PlateX' }}
        </p>
      </div>
      <div
        class="col-md-2 col-12 d-flex align-items-center justify-content-center gap-4 my-3 my-lg-0"
      >
        <a
          href="https://www.facebook.com/profile.php?id=100093000570664"
          style="max-width: 25px"
          class="d-block bg"
          target="_blank"
        >
          <object
            class="d-block mx-auto w-100"
            style="pointer-events: none"
            data="./../../../assets/facebook.svg"
          ></object>
        </a>

        <a
          href="https://www.instagram.com/plates"
          style="max-width: 25px"
          class="d-block"
          target="_blank"
        >
          <object
            class="d-block mx-auto w-100"
            style="pointer-events: none"
            data="./../../../assets/instagram.svg"
          ></object>
        </a>

<!--        <a-->
<!--          href="https://www.twitter.com/platex_uk"-->
<!--          style="max-width: 25px"-->
<!--          class="d-block"-->
<!--          target="_blank"-->
<!--        >-->
<!--          <object-->
<!--            class="d-block mx-auto w-100"-->
<!--            style="pointer-events: none"-->
<!--            data="./../../../assets/twitter.svg"-->
<!--          ></object>-->
<!--        </a>-->
      </div>
      <div class="col-md-5 col-12 pe-0">
        <p
          class="w-100 d-block fs-md-12 my-0 text-white lh-base text-center text-lg-end"
        >
          Copyright 2020 - {{ currYear }} PlateX
        </p>
      </div>
    </div>
  </div>
</div>
